/* eslint-disable camelcase */
import { getBaseinfo, getVipinfo } from '../../apis/personalCenter';
import { datetime_to_unix, getUrlParam } from '@/utils/util';

const USER_INFO = 'USER_INFO',
  NICK_FLAG = 'NICK_FLAG',
  AVATAR_FLAG = 'AVATAR_FLAG',
  VIP_INFO = 'VIP_INFO';

const initState = {
  baseInfo: {}, //基本信息
  vipInfo: {}, //vip信息
  flagNickname: false, //全局控制显示修改昵称弹框
  flagAvatar: false//全局控制显示修改头像弹框
}

// reducer
export function personalCenter(state = initState, action) {
  switch (action.type) {
    case USER_INFO:
      return { ...state, baseInfo: action.baseInfo }
    case NICK_FLAG:
      return { ...state, flagNickname: action.flagNickname }
    case AVATAR_FLAG:
      return { ...state, flagAvatar: action.flagAvatar }
    case VIP_INFO:
      return { ...state, vipInfo: action.vipInfo }
    default:
      return state
  }
}

// actions creater
function info(data) {
  return { type: USER_INFO, baseInfo: data }
}

function nicknameFlag(data) {
  return { type: NICK_FLAG, flagNickname: data }
}

function avatarFlag(data) {
  return { type: AVATAR_FLAG, flagAvatar: data }
}

function vip(data) {
  return { type: VIP_INFO, vipInfo: data }
}

// 暴露方法
export function changeFlag(param) {
  return dispatch => {
    dispatch(nicknameFlag(param))
  }
}
export function changeAvatarFlag(param) {
  return dispatch => {
    dispatch(avatarFlag(param))
  }
}
export function getInfo(param) {
  return dispatch => {
    getBaseinfo().then(res => {
      if (res.code == '200') {
        let userid = getUrlParam('Uid'),
          key = getUrlParam('Key'),
          data = res.data;
        data.Uid = userid;
        data.key = key;
        dispatch(info(data))
      }
    })
  }
}
export function getVip(param) {
  return dispatch => {
    getVipinfo().then(res => {
      if (res.code == '200') {
        let data = res.data
        if (data.vip_type) {
          let deadCount = (datetime_to_unix(data.dead_date) - Date.parse(new Date()) / 1000) / (60 * 60 * 24);
          data.dead_count = Math.ceil(deadCount);
          for (const key in data) {
            switch (key) {
              case 'vip_type':
                if (data[key] === 'N') {
                  data[key] = '黄钻';
                } else {
                  data[key] = '皇冠会员';
                }
                break;
              default:
                break;
            }
          }
          dispatch(vip(data))
        } else {
          let data = {
            vip_type: '普通玩家',
            vip_grade: 1,
            vip_experience: 0,
            upgrade_experience: 1
          }
          dispatch(vip(data))
        }
      }
    })
  }
}
